import React from "react";
import NewPortfolio from "./Projects/new_portfolio";

export default function App() {
  return (
    <div>
      <NewPortfolio />
    </div>
  );
}
